export const DEFAULT_ORG_KEY = "portal-rapihogar";

const LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1", "::1"]);
const PREVIEW_HOST_PREFIX = /^pr-(?:\d+-)?/;

function firstHostnameLabel(value: string): string {
  const label = (value.split(".")[0] || "").replace(PREVIEW_HOST_PREFIX, "");
  return label || DEFAULT_ORG_KEY;
}

export function resolveOrganizationKey(
  hostname = window.location.hostname
): string {
  if (LOCAL_HOSTNAMES.has(hostname)) {
    return import.meta.env.VITE_ORG_KEY || DEFAULT_ORG_KEY;
  }

  return firstHostnameLabel(hostname);
}

export function resolveHostnameTrait(
  hostname = window.location.hostname
): string {
  if (LOCAL_HOSTNAMES.has(hostname)) {
    const orgKey = import.meta.env.VITE_ORG_KEY;
    return orgKey ? firstHostnameLabel(orgKey) : hostname;
  }

  return firstHostnameLabel(hostname);
}
